import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { AddKnowledgeBaseFolderForm } from './AddKnowledgeBaseFolderForm';
import { AddFolderKnowledgeBaseIcon } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseIcons/CurrentKnowledgeBaseIcons';
import { Button } from 'src/components/ui/button';
import type { TreeNode } from 'src/utils/fileUtils';

export const AddKnowledgeBaseFolderModal = ({
  disabled = false,
  handleAddFolderItem,
  item = null,
}: {
  disabled?: boolean;
  handleAddFolderItem: (name: string) => void;
  // The folder being renamed, if any.
  item?: TreeNode | null;
}) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
  };

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <Button
          variant="outline"
          type="button"
          className="min-w-24 flex flex-fow gap-2 text-ebony_opacity_80 text-base-xs"
        >
          <span>Add Folder</span>
          <AddFolderKnowledgeBaseIcon />
        </Button>
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle>{'New folder'}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <AddKnowledgeBaseFolderForm
            handleAddFolderItem={handleAddFolderItem}
            close={closePopup}
            item={item}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
